import { View } from 'react-native';
import React from 'react';
import AzulLogoSVG from '~/assets/svgs/insurance-companies/azul-logo.svg';
import HdiLogoSVG from '~/assets/svgs/insurance-companies/hdi-logo.svg';
import PortoLogoSVG from '~/assets/svgs/insurance-companies/porto-logo.svg';
import SuhaiLogoSVG from '~/assets/svgs/insurance-companies/suhai-logo.svg';

interface LogoInterface {
  logo: string;
  component: React.ReactElement;
}

const LOGOS: LogoInterface[] = [
  { logo: 'azul', component: <AzulLogoSVG /> },
  { logo: 'hdi', component: <HdiLogoSVG /> },
  { logo: 'porto', component: <PortoLogoSVG /> },
  { logo: 'suhai', component: <SuhaiLogoSVG /> },
];

interface Props {
  refLogo: string;
}

const InsuranceLogo: React.FC<Props> = ({ refLogo }) => {
  return (
    <View className="w-12 h-12">
      {LOGOS.find((item) => item.logo === refLogo)?.component}
    </View>
  );
};

export default InsuranceLogo;
